<template>
    <!--弹窗-->
    <el-dialog width="500px" :title="title" :visible.sync="visible" :before-close="handleClose">
        <el-form ref="formData" :model="formData" label-width="150px" :rules="rules">
        <el-form-item label="信用额度(人民币)：" prop="credit">
            <el-input v-model="formData.credit" style="width: 200px;margin-right:20px;" placeholder="请输入充值金额" @keyup.enter.native="submitForm('formData')"></el-input>
        </el-form-item>
        </el-form>
        <el-row style="margin-top:17px; ">
        <el-button
            style="float:right;margin-left:6px;"
            size="mini"
            type="danger"
            plain
            @click="handleClose(true)"
        >取 消</el-button>
        <el-button style="float:right" size="mini" type="primary" @click="submitForm('formData')" :loading="loading">确定</el-button>
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from "@/api/user/user";
export default {
    data() {
        return {
            loading: false,
            rules: {
                credit: [
                    {
                        required: true,
                        message: "请输入充值金额",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    props: {
        formData: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        },
        credit: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: ""
        }
    },
    methods: {
        // 保存信息
        submitForm(formData) {
            this.$refs[formData].validate(valid => {
                if (valid) {
                    if (Number(this.credit) == Number(this.formData.credit)) {
                        this.$message({
                            type: "error",
                            message: "原信用值没变更！"
                        });
                        return;
                    }
                    this.loading = true;
                    api.credit_limit(this.formData)
                        .then(res => {
                            if (res.code === 0) {
                                // 提交成功, 关闭窗口, 刷新列表
                                this.$message({
                                    message: "赠送成功",
                                    type: "success"
                                });
                                this.handleClose(false);
                            } else {
                                this.loading = false;
                                this.$message({
                                    type: "error",
                                    message: res.message
                                });
                            }
                        })
                        .catch(() => {
                            this.$message({
                                message:
                                    "网络出现错误，请刷新页面查看信用额度是否有更改！",
                                type: "error"
                            });
                        });
                } else {
                    this.$message({
                        type: "error",
                        message: "请填写相应内容！"
                    });
                }
            });
        },
        // 关闭弹窗
        handleClose(isshow) {
            this.$refs["formData"].resetFields();
            this.loading = false;
            this.$emit("close-callback", isshow);
        }
    }
};
</script>
